<template>
  <div class="dashboard-page dark-theme">
    <!-- 顶部公告栏 -->
    <div class="announcement-banner" v-if="notices && notices.length > 0">
      <div class="announcement-inner">
        <a-icon type="bulb" class="announcement-icon" />
        <div class="announcement-text" :key="currentNoticeIndex">
          {{ notices[currentNoticeIndex].message }}
        </div>
      </div>
    </div>

    <!-- 主内容区 -->
    <div class="dashboard-container">
      <!-- 流量概览区 -->
      <div class="overview-section">
        <!-- 剩余流量 -->
        <div class="overview-card split-card right-card">
          <div class="traffic-info">
            <div class="traffic-label">{{ translate('database.header.contant1') }}</div>
            <div class="traffic-value">{{ flowoverdue }}GB <span class="traffic-total">/ {{ flow }}GB</span></div>
          </div>
          <div class="traffic-notice">
            <a-icon type="info-circle" />
            <span>{{ translate('database.header.contant8') }}</span>
          </div>
        </div>
      </div>

      <!-- 标签页切换 -->
      <a-tabs v-model="value" @change="changeTabs" class="modern-tabs">
        <a-tab-pane :tab="translate('database.tab.title1')" key="dtzz">
          <div class="tab-content">
            <!-- 左侧：表单配置区 -->
            <div class="config-section">
              <div class="section-card form-card">
                
                <div class="form-row">
                  <div class="form-label"><span class="required">*</span>{{ translate('database.header.contant3') }}</div>
                  <div class="form-content">
                    <a-select :placeholder="translate('database.header.contant3')" v-model="country" @change="changeCode" show-search optionFilterProp="children" style="width: 100%;">
                      <template v-if="currentLanguage === 'en'">
                        <a-select-option v-for="item in IsoCodeList" :value="item.iso" :key="item.iso">{{ item.countriesEn }}</a-select-option>
                      </template>
                      <template v-else-if="currentLanguage === 'zh'">
                        <a-select-option v-for="item in IsoCodeList" :value="item.iso" :key="item.iso">{{ item.countriesCn }}</a-select-option>
                      </template>
                    </a-select>
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-label"><span class="required">*</span>{{ translate('database.header.contant4') }}</div>
                  <div class="form-content">
                    <a-select :placeholder="translate('database.header.contant4')" v-model="state" @change="changeState" style="width: 100%;">
                      <a-select-option v-for="item in AreaList" :value="item.region" :key="item.region">{{ currentLanguage === 'zh' ? item.region : item.region }}</a-select-option>
                    </a-select>
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-label"><span class="required">*</span>{{ translate('database.header.contant5') }}</div>
                  <div class="form-content">
                    <a-select :placeholder="translate('database.header.contant5')" v-model="citycode" @change="changeCity" style="width: 100%;">
                      <a-select-option v-for="item in CityList" :value="item.city" :key="item.city">{{ currentLanguage === 'zh' ? item.city : item.city }}</a-select-option>
                    </a-select>
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-label"><span class="required">*</span>{{ translate('database.banner.contant1') }}</div>
                  <div class="form-content">
                    <a-select v-model="hostValue" @change="handleHostChange" style="width: 100%;">
                      <a-select-option :value="formData.host" :key="formData.host">{{ formData.host }}</a-select-option>
                      <a-select-option value="us.ipipbright.net" key="us.ipipbright.net">us.ipipbright.net</a-select-option>
                      <a-select-option value="eu.ipipbright.net" key="eu.ipipbright.net">eu.ipipbright.net</a-select-option>
                    </a-select>
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-label"><span class="required">*</span>{{ translate('database.banner.contant19') }}</div>
                  <div class="form-content">
                    <div class="protocol-buttons">
                      <!-- <div class="protocol-btn">Http(支持Https流量)</div> -->
                      <div class="protocol-btn active">Socks5</div>
                    </div>
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-label"><span class="required">*</span>{{ translate('database.banner.contant20') }}</div>
                  <div class="form-content time-mode-content">
                    <a-select :placeholder="translate('database.banner.contant12')" @change="changeTimes" style="width: 200px;">
                      <a-select-option :label="translate('database.banner.contant14')" value="0" :key="0">{{ translate('database.banner.contant14') }}</a-select-option>
                      <a-select-option :label="translate('database.banner.contant15')" value="1" :key="1">{{ translate('database.banner.contant15') }}</a-select-option>
                    </a-select>
                    <span class="time-text">{{ translate('database.banner.contant21') }}</span>
                    <a-select :placeholder="translate('database.banner.contant10')" default-value="5" @change="changeTime" style="width: 80px;">
                      <a-select-option v-for="item in proxyTimeList" :value="item.value" :key="item.value">{{ item.value }}</a-select-option>
                    </a-select>
                    <span class="time-text">{{ translate('database.banner.contant22') }}</span>
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-label">{{ translate('database.banner.contant23') }}</div>
                  <div class="form-content security-content">
                    <div class="security-info">
                      <span class="sec-label">{{ translate('database.banner.contant3') }}</span>
                      <span class="sec-value">{{ formData.username }}</span>
                      <span class="sec-label" style="margin-left: 40px;">{{ translate('database.banner.contant4') }}</span>
                      <span class="sec-value">{{ formData.password }}</span>
                    </div>
                    <a class="modify-link" @click="changeAuthPassword">{{ translate('database.banner.contant24') }}</a>
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-label"><span class="required">*</span>{{ translate('database.header.contant6') }}</div>
                  <div class="form-content">
                    <a-select :placeholder="translate('database.header.contant6')" v-model="sonAccount" @change="changeSon" style="width: 100%;">
                      <a-select-option v-for="item in sonlist" :value="item.username" :key="item.username">{{ item.username }}</a-select-option>
                    </a-select>
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-label"><span class="required">*</span>{{ translate('database.banner.contant25') }}</div>
                  <div class="form-content">
                    <a-select :placeholder="translate('database.banner.contant12')" @change="changeProxy" style="width: 100%;">
                      <a-select-option v-for="item in FormatList" :value="item.dictValue" :key="item.dictCode">{{ item.dictValue }}</a-select-option>
                    </a-select>
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-label"><span class="required">*</span>{{ translate('database.banner.contant26') }}</div>
                  <div class="form-content separator-content">
                    <div class="quantity-wrapper" style="width: 100%;">
                      <a-select :placeholder="translate('database.banner.contant9')" default-value="10" @change="changeLength" style="width: 100px;">
                        <a-select-option v-for="item in proxyListLength" :value="item.value" :key="item.value">{{ item.value }}</a-select-option>
                      </a-select>
                    </div>
                  </div>
                </div>

                <div class="form-actions">
                  <a-button type="primary" @click="getProxyList" class="generate-btn-main">
                    {{ translate('database.banner.contant17') }}
                  </a-button>
                </div>
              </div>
            </div>

            <!-- 右侧：信息与结果区 -->
            <div class="result-section">
              <!-- 顶部信息 -->
              <div class="section-card ip-info-card">
                <div class="ip-info-header">
                  <a-icon type="environment" class="ip-icon" />
                  <span>{{ translate('database.banner.contant2') }}: {{ formData.port }}</span>
                </div>
                <div class="ip-info-warning">
                  {{ translate('database.banner.contant6') }}
                </div>
                <div class="ip-info-desc">
                  {{ translate('database.banner.contant5') }}
                </div>
              </div>

              <!-- 结果区 -->
              <div class="section-card result-box-card">
                <div class="result-header">
                  <span class="result-title">{{ translate('database.banner.contant27') }}</span>
                  <div class="result-actions">
                    <a @click="copy" id="equSN" :data-clipboard-text="this.ProxyContant">{{ translate('database.banner.contant18') }} <a-icon type="copy" /></a>
                    <a @click="downloadTxt">{{ translate('database.banner.contant28') }} <a-icon type="upload" /></a>
                  </div>
                </div>
                <a-textarea 
                  v-model="this.ProxyContant" 
                  read-only 
                  :auto-size="{ minRows: 20, maxRows: 30 }" 
                  class="proxy-result-area"
                />
              </div>
            </div>
          </div>
        </a-tab-pane>
        
        <!-- <a-tab-pane :tab="translate('database.tab.title2')" key="jtzz">
          <div class="static-proxy-section">
            <div class="section-card static-card">
              <div class="card-header">
                <a-icon type="table" class="card-icon" />
                <h3 class="card-title">{{ translate('database.tab.title2') }}</h3>
              </div>
              
              <div class="static-filter">
                <a-select :placeholder="translate('database.tab2.contant1')" @change="changeCodejt" show-search style="width: 250px; margin-right: 16px;">
                  <template v-if="currentLanguage === 'en'">
                    <a-select-option v-for="item in IsoCodeList" :value="item.iso" :key="item.iso">{{ item.countriesEn }}</a-select-option>
                  </template>
                  <template v-else-if="currentLanguage === 'zh'">
                    <a-select-option v-for="item in IsoCodeList" :value="item.iso" :key="item.iso">{{ item.countriesCn }}</a-select-option>
                  </template>
                </a-select>
                <a-select placeholder="socks5" default-value="socks5" style="width: 150px;">
                  <a-select-option value="socks5" :key="0">socks5</a-select-option>
                  <a-select-option value="http" :key="1" disabled>http</a-select-option>
                </a-select>
              </div>
              
              <a-table
                  :columns="columns"
                  :data-source="dataList"
                  :loading="dataLoading"
                  :rowKey="rowKey"
                  :pagination="pagination"
                  :scroll="{ x: 1200 }"
                  class="static-table"
                >
                </a-table>
            </div>
          </div>
        </a-tab-pane> -->
      </a-tabs>
    </div>
  </div>
</template>

<script>
import Clipboard from 'clipboard';
import { saveAs } from 'file-saver';

export default {
  name: 'DynamicResidence',
  inject: ['languageState'],
  computed: {
    currentLanguage() {
      return this.languageState ? this.languageState.languageCode : 'en';
    },
    t() {
      const lang = this.currentLanguage;
      return {
        tabTitle1: lang === 'zh' ? '动态住宅' : 'Dynamic Residential',
        tabTitle2: lang === 'zh' ? '静态住宅' : 'Static dwellings',
        headerContant1: lang === 'zh' ? '剩余动态 residences:' : 'Remaining Dynamic Residences:',
        headerContant2: lang === 'zh' ? '总带宽:' : 'Total bandwidth:',
        headerContant3: lang === 'zh' ? '请选择国家' : 'Please select a country',
        headerContant4: lang === 'zh' ? '请选择地区' : 'Please select a region',
        headerContant5: lang === 'zh' ? '请选择城市' : 'Please select a city',
        headerContant6: lang === 'zh' ? '选择子账户' : 'Select the sub-account',
        headerContant7: lang === 'zh' ? '选择协议' : 'Select the protocol',
        bannerContant1: lang === 'zh' ? '主机' : 'host',
        bannerContant2: lang === 'zh' ? '端口' : 'port',
        bannerContant3: lang === 'zh' ? '用户名' : 'Username',
        bannerContant4: lang === 'zh' ? '密码' : 'password',
        bannerContant5: lang === 'zh' ? '将其放入您的IP/托管设置' : 'Put it into your IP/hosting settings',
        bannerContant6: lang === 'zh' ? '使用指定的端口。每个端口是一个独立的粘性会话，最大长度为120分钟' : 'Use the specified port. Each port is a separate sticky session with a maximum length of 120 minutes',
        bannerContant7: lang === 'zh' ? '您的用户名，对于住宅代理，您会注意到在使用上面的定位选项时用户名会动态变化' : 'Your username, for residential proxies, you will notice that the username changes dynamically when you use the targeting options above',
        bannerContant8: lang === 'zh' ? '您的密码' : 'Your password',
        bannerContant9: lang === 'zh' ? '代理列表长度:' : 'The length of the proxy list:',
        bannerContant10: lang === 'zh' ? '代理时间(分钟):' : 'Agency Time (min):',
        bannerContant11: lang === 'zh' ? '代理链接格式:' : 'Proxy link format:',
        bannerContant12: lang === 'zh' ? '请选择' : 'Please select',
        bannerContant13: lang === 'zh' ? '时间模式:' : 'Timeframe mode:',
        bannerContant14: lang === 'zh' ? '定期更换' : 'Replace it regularly',
        bannerContant15: lang === 'zh' ? '一次换一个' : 'One change at a time',
        bannerContant17: lang === 'zh' ? '生成连接信息' : 'Generate Connection Info',
        bannerContant19: lang === 'zh' ? '代理协议' : 'Proxy Protocol',
        bannerContant20: lang === 'zh' ? 'IP轮转周期' : 'IP Rotation Period',
        bannerContant21: lang === 'zh' ? '每' : 'Every',
        bannerContant22: lang === 'zh' ? '分钟自动切换' : 'minutes auto switch',
        bannerContant23: lang === 'zh' ? '安全策略' : 'Security Policy',
        bannerContant24: lang === 'zh' ? '修改' : 'Modify',
        bannerContant25: lang === 'zh' ? '生成格式' : 'Generate Format',
        bannerContant26: lang === 'zh' ? '提取数量' : 'Extract Quantity',
        bannerContant27: lang === 'zh' ? '线路信息' : 'Line Info',
        bannerContant28: lang === 'zh' ? '导出' : 'Export',
        tab2Contant1: lang === 'zh' ? '请选择国家' : 'Please select a country',
        tab2Contant2: lang === 'zh' ? '主机' : 'host',
        tab2Contant3: lang === 'zh' ? '端口' : 'port',
        tab2Contant4: lang === 'zh' ? '用户名' : 'Username',
        tab2Contant5: lang === 'zh' ? '密码' : 'password',
        tab2Contant6: lang === 'zh' ? 'IP属性' : 'IP attribution',
        tab2Contant7: lang === 'zh' ? '生效时间' : 'Effective time',
        tab2Contant8: lang === 'zh' ? '到期时间' : 'Expiration time',
        resetPassword: lang === 'zh' ? '重置密码' : 'Reset password',
      };
    },
    columns() {
      return [
        {
          title: this.t.tab2Contant2,
          fixed: 'left',
          width: 200,
          align: 'left',
          ellipsis: true,
          dataIndex: 'uid',
          key: 'uid',
        },
        {
          title: this.t.tab2Contant3,
          width: 200,
          ellipsis: true,
          dataIndex: 'creatTime',
          key: 'creatTime',
        },
        {
          title: this.t.tab2Contant4,
          width: 200,
          ellipsis: true,
          dataIndex: 'flow',
          key: 'flow',
        },
        {
          title: this.t.tab2Contant5,
          width: 200,
          ellipsis: true,
          dataIndex: 'flowOverdue1',
          key: 'flowOverdue1',
        },
        {
          title: this.t.tab2Contant6,
          width: 200,
          ellipsis: true,
          dataIndex: 'ipArea',
          key: 'ipArea',
        },
        {
          title: this.t.tab2Contant7,
          width: 200,
          ellipsis: true,
          dataIndex: 'flowOverdue2',
          key: 'flowOverdue2',
        },
        {
          title: this.t.tab2Contant8,
          width: 200,
          ellipsis: true,
          dataIndex: 'flowOverdue3',
          key: 'flowOverdue3',
        },
      ];
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      uid: localStorage.getItem("userId"),
      value: 'dtzz',
      StateName:'',
      CityName:'',
      formData:{
        host:'',
        port:'',
        username:'',
        password:'',
      },
      formatid:'',
      life:5,
      listnum:10,
      proxyType:'socks5',
      citycode:undefined,
      state:undefined,
      dyType:'',
      country:'US',
      selectedMode:0,
      
      rowKey: 'index',
      dataLoading: false,
      tableLayout: 'auto',
      verticalAlign: 'top',
      bordered: true,
      hover: true,
      pagination: {
        defaultPageSize: 10,
        total: 0,
        defaultCurrent: 1,
      },
      dataList:[],
      IsoCodeList:[],
      FormatList:[],
      AreaList:[],
      CityList:[],
      sonlist:[],
      sonAccount:undefined,
      ProxyContant:'',
      flow:'',
      flowoverdue:'',
      proxyListLength :[
        { value: 10 },
        { value: 20 },
        { value: 30 },
        { value: 40 },
        { value: 50 },
        { value: 100 },
        { value: 500 },
        { value: 1000 }
      ],
      proxyTimeList:[],
      timer:null,
      noticeTimer:null,
      notices: [],
      currentNoticeIndex: 0,
      hostValue: 'sp.ipipbright.net',
    };
  },
  mounted(){
    for(let i = 1; i <= 120; i++) {
      this.proxyTimeList.push({ value: i });
    }
    
    this.getIsoCodeList();
    this.getProxyflow();
    this.getFormatList();
    this.getProxyList();
    this.getSonAccountList();
    this.start();
    this.getNoticeList();
  },
  updated(){
    if(this.notices.length > 1 && !this.noticeTimer){
      this.startNoticeTimer();
    }
  },
  methods:{
    translate(key) {
      const lang = this.currentLanguage;
      const translations = {
        'database.tab.title1': lang === 'zh' ? '动态住宅' : 'Dynamic Residential',
        'database.tab.title2': lang === 'zh' ? '静态住宅' : 'Static dwellings',
        'database.header.contant1': lang === 'zh' ? '剩余动态住宅:' : 'Remaining Dynamic Residences:',
        'database.header.contant2': lang === 'zh' ? '总带宽:' : 'Total bandwidth:',
        'database.header.contant3': lang === 'zh' ? '请选择国家' : 'Please select a country',
        'database.header.contant4': lang === 'zh' ? '请选择地区' : 'Please select a region',
        'database.header.contant5': lang === 'zh' ? '请选择城市' : 'Please select a city',
        'database.header.contant6': lang === 'zh' ? '选择子账户' : 'Select the sub-account',
        'database.header.contant7': lang === 'zh' ? '选择协议' : 'Select the protocol',
        'database.header.contant8': lang === 'zh' ? '由于国际网络延迟问题，流量统计会出现波动，一般半小时左右更新，如果出现波动会延长到三小时更新。' : 'Due to international network latency, traffic statistics may fluctuate. It is usually updated in about half an hour, and if there are fluctuations, it will be extended to three hours.',
        'database.banner.contant1': lang === 'zh' ? '主机' : 'host',
        'database.banner.contant2': lang === 'zh' ? '端口' : 'port',
        'database.banner.contant3': lang === 'zh' ? '用户名' : 'Username',
        'database.banner.contant4': lang === 'zh' ? '密码' : 'password',
        'database.banner.contant5': lang === 'zh' ? '将其放入您的IP/托管设置' : 'Put it into your IP/hosting settings',
        'database.banner.contant6': lang === 'zh' ? '使用指定的端口。每个端口是一个独立的粘性会话，最大长度为120分钟' : 'Use the specified port. Each port is a separate sticky session with a maximum length of 120 minutes',
        'database.banner.contant7': lang === 'zh' ? '您的用户名，对于住宅代理，您会注意到在使用上面的定位选项时用户名会动态变化' : 'Your username, for residential proxies, you will notice that the username changes dynamically when you use the targeting options above',
        'database.banner.contant8': lang === 'zh' ? '您的密码' : 'Your password',
        'database.banner.contant9': lang === 'zh' ? '代理列表长度:' : 'The length of the proxy list:',
        'database.banner.contant10': lang === 'zh' ? '代理时间(分钟):' : 'Agency Time (min):',
        'database.banner.contant11': lang === 'zh' ? '代理链接格式:' : 'Proxy link format:',
        'database.banner.contant12': lang === 'zh' ? '请选择' : 'Please select',
        'database.banner.contant13': lang === 'zh' ? '时间模式:' : 'Timeframe mode:',
        'database.banner.contant14': lang === 'zh' ? '定期更换' : 'Replace it regularly',
        'database.banner.contant15': lang === 'zh' ? '一次一换' : 'One change at a time',
        'database.banner.contant16': lang === 'zh' ? '下载' : 'Download',
        'database.banner.contant17': lang === 'zh' ? '生成连接信息' : 'Generate Connection Info',
        'database.banner.contant18': lang === 'zh' ? '复制' : 'Copy',
        'database.banner.contant19': lang === 'zh' ? '代理协议' : 'Proxy Protocol',
        'database.banner.contant20': lang === 'zh' ? 'IP轮转周期' : 'IP Rotation Period',
        'database.banner.contant21': lang === 'zh' ? '每' : 'Every',
        'database.banner.contant22': lang === 'zh' ? '分钟自动切换' : 'minutes auto switch',
        'database.banner.contant23': lang === 'zh' ? '安全策略' : 'Security Policy',
        'database.banner.contant24': lang === 'zh' ? '修改' : 'Modify',
        'database.banner.contant25': lang === 'zh' ? '生成格式' : 'Generate Format',
        'database.banner.contant26': lang === 'zh' ? '提取数量' : 'Extract Quantity',
        'database.banner.contant27': lang === 'zh' ? '线路信息' : 'Line Info',
        'database.banner.contant28': lang === 'zh' ? '导出' : 'Export',
        'database.tab2.contant1': lang === 'zh' ? '请选择国家' : 'Please select a country',
        'database.tab2.contant2': lang === 'zh' ? '主机' : 'host',
        'database.tab2.contant3': lang === 'zh' ? '端口' : 'port',
        'database.tab2.contant4': lang === 'zh' ? '用户名' : 'Username',
        'database.tab2.contant5': lang === 'zh' ? '密码' : 'password',
        'database.tab2.contant6': lang === 'zh' ? 'IP属性' : 'IP attribution',
        'database.tab2.contant7': lang === 'zh' ? '生效时间' : 'Effective time',
        'database.tab2.contant8': lang === 'zh' ? '到期时间' : 'Expiration time',
        'resetPassword': lang === 'zh' ? '重置密码' : 'Reset password',
      };
      return translations[key] || key;
    },
    getNoticeList(){
      this.$request.get('/ums/user/getNoticeList',{
        params: {
          dataType: 'ipipbright'
        }
      }).then((res) => {
        if (res.data.code === 200) {
          this.notices = res.data.data;
        }
      })
      .catch((e) => {
        console.log(e);
      })
    },
    getLoginStatus(){
      this.$request.get('/ums/isLoginStates').then((res) => {
        if (res.data.code === 5000) {
          this.$router.push('/login')
          window.localStorage.clear();
          this.$message.warning('请重新登录！');
        }
      })
      .catch((e) => {
        console.log(e);
      })
    },
    start(){
      this.timer = setInterval(this.getLoginStatus, 10000);
    },
    startNoticeTimer(){
      this.noticeTimer = setInterval(() => {
        this.currentNoticeIndex = (this.currentNoticeIndex + 1) % this.notices.length;
      }, 2000);
    },
    getProxyStaticList() {
      this.$request.post('/consum/getProxyStaticList',
        {
          packageType:this.value,
          uid:this.uid,
          city:this.citycode,
          country:this.country,
          formatid:this.formatid,
          life:this.life,
          listnum:this.listnum,
          proxyType:this.proxyType,
          state:this.state,
          selectedMode:this.selectedMode,

        }
      ).then((res) => {
        if (res.data.code === 200) {
          this.dataList = res.data.data;
        }else{
          this.$message.warning(res.data.msg)
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
      });
    },
    changeCodejt(){
      this.getProxyStaticList()
    },
    changeTabs(){
      if(this.value == 'jtzz'){
        this.getProxyStaticList();
      }else{
        console.log('aaa');
      }
    },
    getIsoCodeList() {
      this.$request.get('/consum/getIsoCodeList').then((res) => {
        if (res.data.code === 200) {
          this.IsoCodeList = res.data.data
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
      });
    },
    getFormatList() {
      this.$request.get('/consum/getFormatList').then((res) => {
        if (res.data.code === 200) {
          this.FormatList = res.data.data;
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
      });
    },
    getSonAccountList() {
      this.$request.get('/ums/Pro/selectSonAccount?id='+ this.uid).then((res) => {
        if (res.data.code === 200) {
          this.sonlist = res.data.data;
        }
      })
      .catch((e) => {
        console.log(e);
      })
    },
    changeCode(e){
      this.StateName = "";
      this.AreaList = [];
      this.CityName = "";
      this.CityList = [];
      this.citycode = null;
      this.state = null;
      this.country = e;
      if(this.dyType === "ipidea" || this.dyType === "ipidea2" || this.dyType === "ipidea3"){
        this.getAreaflow();
      }
      if(this.dyType === "ipidea3"){
        this.getAreaflow();
      }
      if(this.dyType === "ipipgo" || this.dyType === "testipipgo"){
        this.getAreaflow();
      }
      if(this.dyType === "iproyal"){
        this.getCityflow();
      }
      if(this.dyType === "smart" || this.dyType === "testsmart"){
        this.getCityflow();
      }
      this.getCityflow();
      this.getAreaflow();
      this.getProxyList();
    },
    changeState(e){
      this.CityName = "";
      this.state = e;
      this.citycode = null;
      this.getProxyList();
    },
    changeCity(e){
      this.state = "";
      this.StateName = "";
      this.citycode = e;
      this.getProxyList();
    },
    changeSon(e){
      this.sonAccount = e;
      this.getProxyList();
      this.$request.get('/ums/Pro/selectSonAccount?id='+ this.uid).then((res) => {
        if (res.data.code === 200) {
          this.sonlist = res.data.data;
          this.sonlist.forEach((item)=>{
            if(e == item.username){
              this.formData.username = item.username;
              this.formData.host = item.ip;
              this.formData.port = item.port;
              this.formData.password = item.password;
            }
          })
        }
      }).catch((e) => {  console.log(e);})
    },
    changeProxy(e){
      this.FormatList.forEach((item)=>{
        if(e == item.dictValue){
          this.formatid = item.dictCode;
        }
      })
      this.getProxyList();
    },
    changeTimes(e){
      if(e == 1){
        this.selectedMode = 1;
      }else if(e == 0){
        this.selectedMode = 0;
      }
      this.getProxyList();
    },
    changeLength(e){
      this.listnum = e;
      this.getProxyList();
    },
    changeTime(e){
      this.life = e;
      this.getProxyList();
    },
    getAreaflow() {
      this.$request.post('/consum/getStatuList',{datatype:this.dyType,country:this.country}).then((res) => {
        if (res.data.code === 200) {
          this.AreaList = res.data.data;
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
      });
    },
    getCityflow() {
      this.$request.post('/consum/getReginlinkList',{datatype:this.dyType,country:this.country,state:this.state}).then((res) => {
        if (res.data.code === 200) {
          this.CityList = res.data.data;
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
      });
    },
    getProxyflow() {
      this.$request.post('/consum/getProxyflow',{packageType:this.value,uid:this.uid}).then((res) => {
        console.log(this.formData);
        if (res.data.code === 200) {
          this.flow = res.data.data.flow;
          this.dyType = res.data.data.datatype;
          this.flowoverdue = Number(res.data.data.flow) - Number(res.data.data.flowoverdue);
          this.formData = {...res.data.data}
          this.getCityflow();
          this.getAreaflow();
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
      });
    },
    changeAuthPassword(){
      let changeAccount = this.sonlist.filter((item)=>{
        return item.type == "master"
      })
      console.log('this.sonlist', changeAccount[0]);
      this.$request.post('/ums/updateAuthPassword',{
        nodeId: changeAccount[0].nodeId,
        password:changeAccount[0].password
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message({
            message: '修改成功',
            type: 'success'
          });
          this.getProxyflow();
          this.getFormatList();
          this.getProxyList();
        }
      })
    },
    handleHostChange(e){
      this.hostValue = e;
      this.getProxyList();
    },
    getProxyList() {
      this.$request.post('/consum/getProxyListPro',
        {
          packageType:this.value,
          uid:this.uid,
          city:this.citycode,
          country:this.country,
          formatid:this.formatid,
          life:this.life,
          listnum:this.listnum,
          proxyType:this.proxyType,
          state:this.state,
          uname:this.sonAccount,
          selectedMode:this.selectedMode,
          hostValue: this.hostValue,

        }
      ).then((res) => {
        if (res.data.code === 200) {
          this.ProxyContant = res.data.data.join('\n')
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
      });
    },
    copy(){
      var clipboard = new Clipboard('#equSN')
      clipboard.on('success', () => {
        this.$message.success('已成功复制到粘贴板')
        clipboard.destroy()
      })
      clipboard.on('error', () => {
        this.$message.warning('该浏览器不支持复制')
        clipboard.destroy()
      })
    },
    downloadTxt() {
      let str = this.ProxyContant;
      let strData = new Blob([str], { type: 'text/plain;charset=utf-8' });
      saveAs(strData, 'ipipbright_'+ this.country +'.txt');
    },
  },
  beforeDestroy(){
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    if (this.noticeTimer) {
      clearInterval(this.noticeTimer);
      this.noticeTimer = null;
    }
  },
};
</script>

<style scoped lang="less">
// 深色主题全局样式
.dark-theme {
  background: #2d2c28;
  color: #ffffff;
  // min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
}

// 公告栏样式
.announcement-banner {
  background: rgba(21, 129, 198, 0.1);
  border: 1px solid rgba(21, 129, 198, 0.3);
  padding: 16px 20px;
  margin-bottom: 24px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  margin: 20px;
  position: relative;
  overflow: hidden;
}

.announcement-banner::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(to bottom, #1581c6, #00ea90);
}

.announcement-inner {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
}

.announcement-icon {
  color: #00ea90;
  font-size: 22px;
}

.announcement-text {
  font-size: 14px;
  color: #ddd;
  font-weight: 500;
}

// 主容器样式
.dashboard-container {
  padding: 0 20px 20px;
  margin: 0 auto;
}

// 概览卡片样式
.overview-section {
  display: flex;
  gap: 20px;
  margin-bottom: 24px;
}

.split-card {
  flex: 1;
  background: #33342e;
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.split-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(to right, #1581c6, #00ea90);
}

.split-card:hover {
  transform: translateY(-2px);
  border-color: rgba(21, 129, 198, 0.3);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.3);
}

.card-header-flex {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.card-title-small {
  font-size: 16px;
  color: #fff;
  font-weight: 600;
}

.status-badge {
  background: rgba(21, 129, 198, 0.2);
  color: #1581c6;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
}

.progress-wrapper {
  margin-top: 16px;
}

.progress-info {
  display: flex;
  justify-content: space-between;
  color: #aaa;
  font-size: 14px;
  margin-bottom: 8px;
}

.right-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.traffic-label {
  font-size: 14px;
  color: #aaa;
  margin-bottom: 8px;
}

.traffic-value {
  font-size: 32px;
  font-weight: 700;
  color: #00ea90;
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.traffic-total {
  font-size: 18px;
  color: #aaa;
  font-weight: 500;
}

.traffic-notice {
  font-size: 13px;
  color: #888;
  display: flex;
  align-items: flex-start;
  max-width: 450px;
  line-height: 1.5;
  background: rgba(255, 255, 255, 0.03);
  padding: 12px 16px;
  border-radius: 8px;
}

.traffic-notice .anticon {
  margin-top: 3px;
  margin-right: 8px;
  font-size: 14px;
  color: #1581c6;
}

:deep(.ant-progress-bg) {
  background: linear-gradient(to right, #1581c6, #00ea90) !important;
}

// 现代标签页样式
.modern-tabs {
  background: #33342e;
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  
  :deep(.ant-tabs-nav) {
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  }
  
  :deep(.ant-tabs-tab) {
    color: #888 !important;
    font-size: 16px;
    font-weight: 600;
    padding: 12px 24px;
    margin: 0 8px;
    border-radius: 8px;
    transition: all 0.3s ease;
  }
  
  :deep(.ant-tabs-tab-active) {
    color: #fff !important;
    background: rgba(21, 129, 198, 0.1);
    border: 1px solid rgba(21, 129, 198, 0.3);
  }
  
  :deep(.ant-tabs-ink-bar) {
    display: none !important;
  }
  
  :deep(.ant-tabs-tab:hover) {
    color: #1581c6 !important;
  }
}

// 标签页内容
.tab-content {
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  gap: 24px;
  margin-top: 24px;
}

.section-card {
  background: #33342e;
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.form-card {
  background: #33342e;
  border-radius: 8px;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.form-row {
  display: flex;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.form-row:last-child {
  border-bottom: none;
}

.form-label {
  width: 140px;
  color: #aaa;
  font-size: 14px;
  display: flex;
  align-items: center;
}

.required {
  color: #f5222d;
  margin-right: 4px;
}

.form-content {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 12px;
}

.download-list-link {
  color: #00ea90;
  white-space: nowrap;
  cursor: pointer;
}

.protocol-buttons {
  display: flex;
  gap: 8px;
}

.protocol-btn {
  padding: 6px 16px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  color: #aaa;
  cursor: pointer;
  transition: all 0.3s;
}

.protocol-btn.active {
  background: rgba(0, 234, 144, 0.1);
  color: #00ea90;
  border-color: #00ea90;
}

.time-mode-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.time-text {
  color: #aaa;
}

.security-content {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.security-info {
  background: rgba(255, 255, 255, 0.02);
  padding: 8px 16px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.sec-label {
  color: #aaa;
}

.sec-value {
  color: #fff;
  font-weight: 600;
}

.modify-link {
  color: #ffffff !important;
  cursor: pointer;
  text-decoration: underline;
}

.modify-link:hover {
  color: #00ea90 !important;
}

.separator-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.quantity-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
}

.quantity-label {
  color: #aaa;
}

.form-actions {
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
}

.generate-btn-main {
  background: #00ea90 !important;
  border: none !important;
  color: #000 !important;
  font-weight: 600 !important;
  height: 40px !important;
  padding: 0 24px !important;
}

.generate-api-btn {
  background: transparent !important;
  border: 1px solid #00ea90 !important;
  color: #00ea90 !important;
  height: 40px !important;
  padding: 0 24px !important;
}

.form-footer-link {
  padding: 16px 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.form-footer-link a {
  color: #aaa;
  font-size: 12px;
  cursor: pointer;
}

.form-footer-link a:hover {
  color: #fff;
}

/* Result Section */
.ip-info-card {
  padding: 16px;
  margin-bottom: 24px;
}

.ip-info-header {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #fff;
  font-size: 14px;
  margin-bottom: 12px;
}

.ip-icon {
  color: #1581c6;
}

.ip-info-warning {
  color: #f5222d;
  font-size: 13px;
  margin-bottom: 8px;
}

.ip-info-desc {
  color: #aaa;
  font-size: 12px;
}

.result-box-card {
  padding: 0;
  overflow: hidden;
}

.result-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.result-title {
  color: #fff;
  font-size: 14px;
  font-weight: 600;
}

.result-actions {
  display: flex;
  gap: 16px;
}

.result-actions a {
  color: #aaa;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
}

.result-actions a:hover {
  color: #fff;
}

.proxy-result-area {
  border: none !important;
  background: transparent !important;
  padding: 16px !important;
  color: #00ea90 !important;
}

// 选择器和输入框的全局暗黑风格
:deep(.ant-input),
:deep(.ant-input-number),
:deep(.ant-input-textarea),
:deep(.ant-input-textarea > textarea),
:deep(.ant-select),
:deep(.ant-select-selection),
:deep(.ant-select-selector) {
  background: #1f1e1b !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  border-radius: 8px !important;
  color: #fff !important;
  transition: all 0.3s ease !important;
  box-shadow: none !important;
}

:deep(.ant-select-selection) {
  height: 44px !important;
}

:deep(.ant-select-selection__rendered) {
  line-height: 42px !important;
  color: #fff !important;
}

:deep(.ant-select-selection:hover),
:deep(.ant-select-selector:hover),
:deep(.ant-input:hover) {
  border-color: #1581c6 !important;
}

:deep(.ant-select-focused .ant-select-selection),
:deep(.ant-select-focused .ant-select-selector),
:deep(.ant-input:focus) {
  border-color: #00ea90 !important;
  box-shadow: 0 0 0 2px rgba(0, 234, 144, 0.2) !important;
}

:deep(.ant-select-selection-selected-value),
:deep(.ant-select-selection-item) {
  color: #ffffff !important;
}

:deep(.ant-select-selection__placeholder),
:deep(.ant-select-selection-placeholder) {
  color: #888888 !important;
}

:deep(.ant-select-arrow) {
  color: #666 !important;
}

// 下拉菜单暗黑风
:deep(.ant-select-dropdown) {
  background: #2d2c28 !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-radius: 8px !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3) !important;
}

:deep(.ant-select-dropdown-menu-item),
:deep(.ant-select-item) {
  color: #ddd !important;
  transition: all 0.2s;
  background: transparent !important;
}

:deep(.ant-select-dropdown-menu-item-active),
:deep(.ant-select-dropdown-menu-item-selected),
:deep(.ant-select-item-option-active),
:deep(.ant-select-item-option-selected) {
  background: rgba(21, 129, 198, 0.2) !important;
  color: #fff !important;
  font-weight: 600;
}

// 生成器操作区样式
.generator-actions {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  padding: 20px;
  background: #1f1e1b;
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
}

.generate-button {
  background: #1581c6 !important;
  border: none !important;
  padding: 0 32px !important;
  height: 44px !important;
  border-radius: 8px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  color: #fff !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 4px 15px rgba(21, 129, 198, 0.3) !important;
}

.generate-button:hover {
  background: #126ba5 !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(21, 129, 198, 0.4) !important;
}

.secondary-actions {
  display: flex;
  gap: 12px;
  margin-left: auto;
}

.action-btn {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  color: #fff !important;
  height: 44px !important;
  padding: 0 20px !important;
  border-radius: 8px !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  transition: all 0.3s ease !important;
}

.action-btn:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: #fff !important;
  transform: translateY(-1px) !important;
}

/* 代理结果文本框 */
.proxy-result {
  margin-top: 10px;
}

:deep(.proxy-result) {
  background: #1f1e1b !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  border-radius: 12px !important;
  color: #00ea90 !important;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace !important;
  font-size: 14px !important;
  line-height: 1.6 !important;
  padding: 20px !important;
  resize: vertical;
  height: auto !important;
}

:deep(.proxy-result:focus) {
  border-color: #1581c6 !important;
  box-shadow: 0 0 0 2px rgba(21, 129, 198, 0.2) !important;
}

// 响应式设计
@media (max-width: 1200px) {
  .tab-content {
    grid-template-columns: 1fr;
  }
  
  .overview-section {
    flex-direction: column;
  }
}

@media (max-width: 768px) {
  .form-row {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .form-label {
    width: 100%;
    margin-bottom: 8px;
  }
  
  .form-content {
    width: 100%;
    flex-direction: column;
    align-items: stretch;
  }
  
  .time-mode-content {
    flex-wrap: wrap;
  }
  
  .security-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .separator-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .form-actions {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>